const convertToAmount = (value: string | number): string => {

    if (value) {

        let str: string = value.toString()?.replaceAll(',', '');

        str = str.replace(/(\d)(?=(\d\d\d)+(?!\d)(?=\.\d)?)/g, "$1,");

        return str;

    }

    return ''

}

export default convertToAmount;